/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {DECLINE_SUCCESSFUL} from "../utils/constants";
import {
    DECLINE_PAYOUT_LOADING, DECLINE_PAYOUT_SUCCESS, LOADING_DECLINE_PAYOUT_FAILED,
} from "../actions/types";
import {daysFetchData} from "../overview/OverviewAction";

export function loadingDeclinePayoutFailed(error) {
    return {
        type: LOADING_DECLINE_PAYOUT_FAILED,
        error
    };
}

export function declinePayoutLoading(bool) {
    return {
        type: DECLINE_PAYOUT_LOADING,
        isLoading: bool
    };
}

export function declinePayoutSuccess(workoutBlock) {
    return {
        type: DECLINE_PAYOUT_SUCCESS,
        workoutBlock
    };
}

export function fetchDeclinePayout() {
    return (dispatch) => {
        dispatch(declinePayoutLoading(true));

        post('declinePayout', {})
            .then((response) => {
                if (response.msg === DECLINE_SUCCESSFUL ) {
                    dispatch(daysFetchData());
                    dispatch(declinePayoutSuccess(response.workoutBlock));
                }
                dispatch(declinePayoutLoading(false));
            })
            .catch((error) => {
                dispatch(loadingDeclinePayoutFailed(error));
                dispatch(declinePayoutLoading(false));
            });
    };
}


// WEBPACK FOOTER //
// ./src/payout/DeclinePayoutAction.js